import { FC } from 'react';

const MiniTile = ({ letter, count }: { letter: string; count?: number }) => (
  <div className="relative w-[36px] h-[36px] flex items-center justify-center rounded-[5px] bg-[#f6f7f8] dark:bg-[#272729] border border-[#d3d6da] dark:border-[#3a3a3c] text-[14px] font-bold uppercase text-[#121213] dark:text-[#d7dadc]">
    {letter}
    {count !== undefined && (
      <span className="absolute bottom-[2px] left-[3px] text-[8px] font-semibold leading-none" style={{ color: 'var(--star-filled)' }}>
        {count}
      </span>
    )}
  </div>
);

const CountsUnlockedNotification: FC = () => (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <div className="w-[28px] h-[28px] flex items-center justify-center rounded-full flex-shrink-0" style={{ backgroundColor: 'color-mix(in srgb, var(--star-filled) 15%, transparent)' }}>
        <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="var(--star-filled)" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </div>
      <h2 className="text-[14px] font-bold text-[#121213] dark:text-[#d7dadc] m-0">
        Letter Counts Unlocked!
      </h2>
    </div>
    <p className="text-[12px] text-[#555759] dark:text-[#a0a3a6] m-0 leading-relaxed">
      Each tile now shows how many remaining words <strong>start</strong> with that letter.
    </p>
    <div className="flex items-center gap-[4px] justify-center py-1">
      <MiniTile letter="S" count={3} />
      <MiniTile letter="H" />
      <MiniTile letter="E" count={1} />
      <MiniTile letter="D" count={2} />
    </div>
    <p className="text-[11px] text-[#787c7e] dark:text-[#818384] m-0 text-center">
      Look for the number in the bottom-left corner
    </p>
  </div>
);

export default CountsUnlockedNotification;
